import humanize from 'underscore.string/humanize';

angular
  .module 'filters'
  .filter 'humanize', ($filter) ->
    (data, toLowerCase) ->
      str = humanize(data)
      if toLowerCase then $filter('lowercase')(str) else str
